import React from 'react';
import _SearchBar from './_SearchBar.scss';
import {withRouter} from 'react-router-dom';
import {parse} from 'qs';

class SearchBar extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.search = this.props.location.search.substr(1);
    this.state = {
      search: this.search !== '' ? parse(this.search).q : ''
    };
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onChange(e) {
    this.setState({[e.target.name]: e.target.value});
  }

  onSubmit(e) {
    e.preventDefault();
    this.props.history.push(`search?q=${this.state.search}`);
  }

  render() {
    return (
      <div className='search-top' id={this.props.id || null}>
        <form name="SearchProductForm" onSubmit={this.onSubmit} noValidate>
          <input type="text" className="search-input" name="search" value={this.state.search} placeholder="Tìm sản phẩm, thương hiệu bạn muốn..." onChange={this.onChange}/>
          <i className="vtd-search"/>
          <button className="btn-search" type="submit">
            <span className='hide-mobile show-tablet'>
              <i className="vtd-search"/>
            </span>
            <span>Tìm kiếm</span>
          </button>
        </form>
      </div>
    );
  }
}

export default withRouter(SearchBar);



// WEBPACK FOOTER //
// ./components/layouts/master/sub-header/SearchBar.jsx